import { useQuery } from "@tanstack/react-query";
import { retryUnlessForbidden } from "../../../utils/queryRetry";
import { agencyWagesQueryOptions } from "../../team/AgencyWages/useAgencyWages";
import { wageSettingsQueryOptions } from "../../team/WageSettings/useWageSettings";

/**
 * DEFAULT: how long a hover card's settings read stays fresh. A card's body mounts on every open, and the
 * app's queries are stale at once, so without this each hover over another name refetches the same rows.
 * A minute covers reading down one breakdown; a save on the settings page updates this same cache entry,
 * so the card never trails an edit made in this tab.
 */
const RULE_CARD_STALE_TIME_MS = 60_000;

/** A card's reads share their page's cache entry, fresh for a while, and give up at once on a refusal. */
const RULE_CARD_READ_OPTIONS = { staleTime: RULE_CARD_STALE_TIME_MS, retry: retryUnlessForbidden } as const;

/**
 * DAT-906 · A department's stored Wage Settings rows, for a hover card — the Team tab's own cache entry,
 * without the tab's load analytics.
 */
export const useRuleCardWageSettings = (departmentId: string) => useQuery({ ...wageSettingsQueryOptions(departmentId), ...RULE_CARD_READ_OPTIONS });

/** DAT-906 · A department's agency rates, for a hover card — Agency Configuration's own cache entry. */
export const useRuleCardAgencyWages = (departmentId: string) => useQuery({ ...agencyWagesQueryOptions(departmentId), ...RULE_CARD_READ_OPTIONS });
